<template>
    <section>
        <div class="row">
            <div class="col-12">
                <prospect-list></prospect-list>
            </div>
        </div>
    </section>
</template>

<script>
import ProspectList from '@/components/prospect/List';

export default {
    components: {
        ProspectList
    }
}
</script>